export * from './cdrVersions.service';
import { CdrVersionsService } from './cdrVersions.service';
export * from './config.service';
import { ConfigService } from './config.service';
export * from './dataBrowser.service';
import { DataBrowserService } from './dataBrowser.service';
export * from './genomics.service';
import { GenomicsService } from './genomics.service';
export const APIS = [CdrVersionsService, ConfigService, DataBrowserService, GenomicsService];
